import { AxiosInstance } from "axios";
import type { SlackChannel, SlackListReference } from "./SlackSourceSettings.types";

export class SlackSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  /** Public and private channels the signed-in user can see, sorted by name. */
  async getChannels(boardId: string, connectionId: string): Promise<SlackChannel[]> {
    const response = await this.client.get<SlackChannel[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/slack/channels`,
    );
    return response.data;
  }

  /** Emoji names the signed-in user has reacted with recently, most used first. */
  async getRecentReactions(boardId: string, connectionId: string): Promise<string[]> {
    const response = await this.client.get<string[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/slack/reactions`,
    );
    return response.data;
  }

  /**
   * Checks a List link or id can be read, and returns the List's id and title. Slack has no
   * method that lists a user's Lists, so the editor asks for a link instead. Rejects with a
   * 400 when the reference is not a List or Slack refuses it.
   */
  async resolveList(
    boardId: string,
    connectionId: string,
    reference: string,
  ): Promise<SlackListReference> {
    const response = await this.client.get<SlackListReference>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/slack/lists/resolve?reference=${encodeURIComponent(reference)}`,
    );
    return response.data;
  }
}
